import { isOfferedLanguage } from '@/utils/languages/languages';

/** The story language a `?language=` link asks for, or null when it isn't an offered language. */
export function initialLanguageFromParam(param: string | null | undefined): string | null {
  if (!param) return null;
  const code = param.trim().toLowerCase();
  return isOfferedLanguage(code) ? code : null;
}
